// extracted by mini-css-extract-plugin
export default {"connecting-audio":"styles_connecting-audio__AapaL"};